import { Box, Button, Typography, Avatar } from "@mui/material";
import { FLOW_HUB_BUTTON_PRIMARY_CONFIG, FLOW_HUB_BUTTON_SECONDARY_CONFIG, FLOW_HUB_NAVBAR_CONFIG } from "../../../../config/flowhub.config";
import { useFlowHubNavbar } from "./hooks/useFlowHubNavbar";
import flownectIcon from "../../../../../../assets/images/flownectlogo.png";

/**
 * IMPORTANT: This navbar component will be bare-bones at the start, only adding
 * more functionality as the "Flow Hub" feature progresses. This is the history
 * of changes:
 *
 * 14/04/2026 - Created the navbar component with the basic layout and color
 * configuration, added "Login" and "Create an Account" buttons.
 *
 * 17/04/2026 - Refactored into folder-based architecture to match the rest of
 * FlowHub. Extracted auth navigation logic into useFlowHubNavbar hook.
 *
 *
 */
const imagenIcon = flownectIcon;
const logoTitle = "Flownect";

export const FlowHubNavbar = () => {
  const { handleLoginClick, handleCreateAccountClick } = useFlowHubNavbar();

  return (
    <Box sx={FLOW_HUB_NAVBAR_CONFIG}>
      <Avatar
        src={imagenIcon}
        sx={{
          display: "flex",
          mr: { xs: -0.7, sm: 1 },
          width: { xs: "35px" },
          height: "auto",
        }}
      />
      <Typography
        variant="h5"
        noWrap
        component="a"
        href="/"
        sx={{
          display: "flex",
          flexGrow: 1,
          fontFamily: "monospace",
          fontWeight: 700,
          color: "inherit",
          textDecoration: "none",
          fontSize: { sm: "1rem", xs: ".8rem" },
          letterSpacing: { sm: ".1rem", xs: "0rem" },
        }}
      >
        {logoTitle}
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <Button sx={FLOW_HUB_BUTTON_SECONDARY_CONFIG} onClick={handleLoginClick}>
          Login
        </Button>
        <Button sx={FLOW_HUB_BUTTON_PRIMARY_CONFIG} onClick={handleCreateAccountClick}>
          Create an Account
        </Button>
      </Box>
    </Box>
  );
};
